import type { ReactNode } from "react";
import { centavosDaMascara, formatarMilhar } from "@caixaflow/shared";

type CampoProps = {
  rotulo: string;
  erro?: string;
  dica?: string;
  children: ReactNode;
};

/** Rótulo + controle + mensagem de erro, no padrão visual dos formulários. */
export function Campo({ rotulo, erro, dica, children }: CampoProps) {
  return (
    <label className={`campo${erro ? " invalido" : ""}`}>
      <span>
        {rotulo} {dica && <span className="dica">· {dica}</span>}
      </span>
      {children}
      {erro && <span className="erro">{erro}</span>}
    </label>
  );
}

type CampoReaisProps = {
  centavos: number | null;
  onChange: (centavos: number | null) => void;
  id?: string;
  autoFocus?: boolean;
};

/**
 * Valor em reais com máscara automática: os dígitos preenchem da direita (digitar 1250 mostra
 * "12,50") e o milhar é separado sozinho. Teclado numérico no celular. Entrega centavos inteiros,
 * ou null com o campo vazio.
 */
export function EntradaReais({ centavos, onChange, id, autoFocus }: CampoReaisProps) {
  const cursorNoFim = (el: HTMLInputElement) => {
    const fim = el.value.length;
    el.setSelectionRange(fim, fim);
  };
  return (
    <input
      id={id}
      inputMode="numeric"
      placeholder="0,00"
      autoComplete="off"
      autoFocus={autoFocus}
      value={centavos === null ? "" : formatarMilhar(centavos)}
      onChange={(e) => {
        const valor = centavosDaMascara(e.target.value);
        // Apagando até zerar, o campo esvazia (em vez de travar em "0,00").
        const apagando = (e.nativeEvent as InputEvent).inputType?.startsWith("delete");
        onChange(valor === 0 && apagando ? null : valor);
      }}
      // A máscara digita sempre no fim, como numa maquininha.
      onFocus={(e) => {
        const el = e.currentTarget;
        requestAnimationFrame(() => cursorNoFim(el));
      }}
      onClick={(e) => cursorNoFim(e.currentTarget)}
    />
  );
}
